import DialogPage from "../DialogPage";
import Text from "../components/Text";
import BranchInfo from "../../../rest/jtmc/models/BranchInfo";
import {View} from "react-native";

export default function BranchWorkingTime({route, navigation}: any) {

    let {branchInfo}: { branchInfo: BranchInfo } = route.params;

    return <DialogPage navigation={navigation} header={"ساعات کاری شعبه"}>
        <View style={{justifyContent: "center", alignItems: "center"}}>
            <Text size={14} weight={500}>{branchInfo.activeTimes}</Text>
        </View>
    </DialogPage>
}
